// plugins/disableLogs.js

export default defineNuxtPlugin(() => {
  if (import.meta.env.PROD) {
    console.log = () => {};
    // or you can override any other stuff you want
  }
})
